package com.steamstreet.vegasful.browser.public

import com.steamstreet.vegasful.browser.account.Account
import com.steamstreet.vegasful.browser.account.GraphQL
import com.steamstreet.vegasful.browser.account.subscriptions.onClick
import com.steamstreet.vegasful.graphql.api.InteractInput
import com.steamstreet.vegasful.graphql.api.InteractionType
import com.steamstreet.vegasful.web.analytics.Analytics
import com.steamstreet.vegasful.web.analytics.SaveGesture
import com.steamstreet.vegasful.web.analytics.pageTypeOf
import kotlinx.browser.window
import org.w3c.dom.Element
import org.w3c.dom.HTMLElement

/**
 * The add to calendar module.
 *
 * Adding to the calendar is the other gesture `event_saved` may mean — see [SaveGesture]. The
 * CALENDAR interaction needs a signed-in user to belong to, and since the control is now revealed
 * only to one, the analytics event goes with it rather than being sent for everyone.
 */
fun addToCalendar(element: Element) {
    val eventId = element.getAttribute("data-event-id")
    val eventName = element.getAttribute("data-event-name")

    // Adding to a calendar requires an account, and there is no login flow
    // behind this control yet. The server renders it hidden, and it is revealed
    // here only once we know the visitor is signed in, so a signed-out visitor
    // is never offered a control that silently does nothing.
    if (!Account.isLoggedIn()) return
    (element as? HTMLElement)?.style?.display = "inline-flex"

    element.onClick {
        eventId?.let {
            Analytics.eventSaved(SaveGesture.CALENDAR, it, pageTypeOf(window.location.pathname))
        }

        try {
            GraphQL.mutation {
                subscriptions {
                    interact(InteractInput(InteractionType.CALENDAR, "events/${eventId}"))
                }
            }
            notify(
                eventName?.let { "$it has been added to your calendar" }
                    ?: "The event has been added to your calendar"
            )
        } catch (t: Throwable) {
            // Tell the visitor first. Reporting the failure is itself a GraphQL
            // mutation over the transport that has just failed, so it will
            // usually fail as well, and doing it first would swallow the one
            // message the visitor actually needs.
            notify("We couldn't add that event to your calendar. Please try again.")
            try {
                GraphQL.logError("Failed to add event to calendar", t)
            } catch (reportingFailure: Throwable) {
                console.warn("Could not report a failed calendar add")
            }
        }
    }
}
